import { UIText1 } from '@cian/ui-kit';
import {
  IconProduct3DPlan16,
  IconProductApartmentPlan16,
  IconMediaPhoto16,
  IconActionPlan16,
  IconMediaVideo16,
  ISVGIconProps,
} from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './Control.css';
import { EMediaType } from '../../../../types';
import { IInfoControlConfig } from '../../types';

interface IControlProps {
  active: boolean;
  config: IInfoControlConfig;
  onClick?(): void;
}

const ICONS_MAP: { [key in IInfoControlConfig['type']]: React.ComponentType<React.PropsWithChildren<ISVGIconProps>> } =
  {
    [EMediaType.Layout]: IconActionPlan16,
    [EMediaType.Photo]: IconMediaPhoto16,
    [EMediaType.Video]: IconMediaVideo16,
    [EMediaType.Tour]: IconProduct3DPlan16,
    [EMediaType.FloorPlan]: IconProductApartmentPlan16,
  };

export const Control: React.FC<React.PropsWithChildren<IControlProps>> = ({ config, onClick, active }) => {
  const Icon = React.useMemo(() => ICONS_MAP[config.type], [config.type]);

  /* istanbul ignore next */
  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();

      if (onClick) {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <li>
      <button className={cx(styles['button'], active && styles['button--active'])} onClick={handleClick}>
        <span className={styles['icon']}>
          <Icon display="block" color="icon-inverted-default" />
        </span>
        <UIText1 fontWeight="bold" color="text-inverted-default">
          {config.label}
        </UIText1>
      </button>
    </li>
  );
};
